import { Input, Flex, FormField } from '@zillow/constellation';
import React from 'react';
import { prettyManualCheckDisbursementCategory } from 'types/accounting/eManualCheckDisbursementCategory';
import { ICheckDisbursementFormData } from 'types/order/escrow/checks/ICheckDisbursementFormData';
import { IManualCheckDisbursementData } from 'types/order/escrow/IManualCheckDisbursementData';
import { currencyDisplay } from 'utilities/shared/currencyDisplay';

interface IVoidCheckDetailsProps {
  checkDisbursement: IManualCheckDisbursementData | ICheckDisbursementFormData;
}

export const VoidCheckDetails: React.FC<IVoidCheckDetailsProps> = ({ checkDisbursement }) => {
  return (
    <Flex display={'flex'} flexDirection={'column'} gap={1}>
      <Flex display={'flex'} flexDirection={'row'} gap={1}>
        <FormField
          label="Amount"
          control={<Input value={currencyDisplay(checkDisbursement.amountCents, true)} disabled />}
        />
        <FormField label="Check Number" control={<Input value={checkDisbursement.checkNumber ?? ''} disabled />} />
        {checkDisbursement.category && (
          <FormField
            label="Category"
            control={
              <Input
                value={prettyManualCheckDisbursementCategory[checkDisbursement.category] ?? checkDisbursement.category}
                disabled
              />
            }
          />
        )}
      </Flex>
      <FormField label={'Name'} control={<Input value={checkDisbursement.name ?? ''} disabled />} />
      <FormField label="Memo" control={<Input value={checkDisbursement.memo ?? ''} disabled />} />
    </Flex>
  );
};
